class FontIcons extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="font-icons">
          Font Icons
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-font-icon" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Icon in containers</h4>
              <div className="demo__code">
                <CodeBlock lang="html">{`
<div class="icon-demo apple">Apple icon at the beginning</div>
<div class="icon-demo linux">Linux icon at the end</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">{`
.icon-demo {
  &.apple {
    @include font-icon(apple);
  }

  &.linux {
    @include font-icon(linux, after);
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="icon-demo apple">Apple icon at the beginning</div>
                  <div className="icon-demo linux">Linux icon at the end</div>
                </Output>
              </div>
            </div>

            <div className="demo">
              <h4 className="demo__title">Icon in buttons</h4>
              <div className="demo__code">
                <CodeBlock lang="html">{`
<button class="icon-demo button">Icon inside button</button>
<span>Icon only button:</span>
<button class="icon-demo button-no-text">Button with icon only</button>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">{`
.icon-demo {
  &.button {
    @include button();
    @include font-icon(futbol-o);
    display: block;
  }

  &.button-no-text {
    @include button();
    @include font-icon(bomb);
    @include hide-text();

    &:before {
      color: $white;
    }
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <button className="icon-demo button">Icon inside button</button>
                  <span>Icon only button:</span>
                  <button className="icon-demo button-no-text">Button with icon only</button>
                </Output>
              </div>
            </div>

            <div className="demo">
              <h4 className="demo__title">Animated icon</h4>
              <div className="demo__code">
                <CodeBlock lang="html">{`
<div class="icon-demo spinner">Spinner</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">{`
.icon-demo {
  &.spinner {
    @include font-icon(refresh);
    @include hide-text();

    &:before {
      animation: spinner 3s linear infinite;
      color: $pure-black;
      font-size: 100px;
      height: 100px;
      line-height: 1;
      text-align: center;
      transform-origin: 50% 50%;
      width: 100px;
    }

    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="icon-demo spinner">Spinner</div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
